import {ScreenId} from "@assets";

const constant = {
  MOBILE_WIDTH: 540,
  TABLET_WIDTH: 809,
  REGEX: {
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  },
  LINK: {
    KAKAOTALK: "https://pf.kakao.com/_JRFwn",
  },
  PRODUCT_NAME: [{title: "시그니처"}, {title: "리브온 250"}] as {
    title: string;
  }[],
  CONTENT_DIV_ID: "content_div",
  HOME_PRODUCT_DIV_ID: "home_product_div",
  CS_CLICK: () => {
    const userAgent = navigator.userAgent;
    const isMobile =
      userAgent.match(
        /iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i,
      ) != null || userAgent.match(/LG|SAMSUNG|Samsung/) != null;
    if (isMobile) {
      window.open("tel:01083784485");
    } else {
      window.alert("전화번호: 010-8378-4485");
    }
  },
};

export default constant;
